import { Signal } from "../core/Signal.js";

export class Resize {

    //Disable creation
    private constructor() {

    }

    public static create(element: Element = null): ResizeSignal {
        return new ResizeSignal(element);
    }

    public static multi(...elements: Element[]): ResizeMultiSignal {
        return new ResizeMultiSignal(...elements);
    }
}

export class ResizeMultiSignal extends Signal<[ResizeObserverEntry[]]> {

    private _elements: Element[] = [];

    private static _observer: ResizeObserver = null;
    private static _instances: ResizeMultiSignal[] = [];

    constructor(...elements: Element[]) {
        super();

        ResizeMultiSignal.createObserver();
        ResizeMultiSignal._instances.push(this);

        this.addElements(...elements);
    }

    public get element(): Element {
        return this._elements[0];
    }

    public set element(element: Element) {

        if (this._elements[0] == element) {
            return;
        }

        if (this._elements.length > 0) {
            this.removeElements(this._elements[0]);

            if (element) {
                this.addElements(element);

                if (this._elements.length > 1) {
                    const index = this._elements.indexOf(element);
                    this._elements.splice(index, 1);
                    this._elements.unshift(element);
                }
            }

        } else {
            if (element) {
                this.addElements(element);
            }
        }
    }

    public addElements(...elements: Element[]): this {
        for (const element of elements) {
            if (this._elements.indexOf(element) === -1) {
                if (!this.isObserved(element)) {
                    ResizeMultiSignal._observer.observe(element);
                }
                this._elements.push(element);
            }
        }

        return this;
    }

    public removeElements(...elements: Element[]): this {
        for (const element of elements) {
            const index = this._elements.indexOf(element);
            if (index !== -1) {
                this._elements.splice(index, 1);
                if (!this.isObserved(element)) {
                    ResizeMultiSignal._observer.unobserve(element);
                }
            }
        }

        return this;
    }

    private isObserved(element: Element): boolean {
        for (const instance of ResizeMultiSignal._instances) {
            if (instance._elements.indexOf(element) !== -1)
                return true;
        }
        return false;
    }

    public dispose(): void {
        this.removeElements(...this._elements);
        this._elements = null;
        ResizeMultiSignal._instances.splice(ResizeMultiSignal._instances.indexOf(this), 1);
        super.dispose();
    }

    private static createObserver(): void {
        if (this._observer)
            return;
        this._observer = new ResizeObserver((entries) => {

            const listeners: ResizeMultiSignal[] = [];
            for (const entry of entries) {
                for (const instance of ResizeMultiSignal._instances) {
                    if (instance._elements.indexOf(entry.target) !== -1
                        && listeners.indexOf(instance) === -1) {
                        listeners.push(instance);
                    }
                }
            }

            for (const listener of listeners) {
                listener.dispatch(entries);
            }
        });
    }
}

export class ResizeSignal extends Signal<[Element, DOMRectReadOnly]> {

    private _element: Element = null;

    private static _observer: ResizeObserver = null;

    constructor(element: Element = null) {
        super();

        ResizeSignal.createObserver();
        this.element = element;
    }

    public get element(): Element {
        return this._element;
    }

    public set element(element: Element) {
        if (this._element === element)
            return;
        if (this._element) {
            var before: any = this._element;
            before._resizers.splice(before._resizers.indexOf(this), 1);
            if (before._resizers.length === 0) {
                ResizeSignal._observer.unobserve(this._element);
                before._resizers = undefined;
            }
        }
        this._element = element;
        if (this._element) {
            var after: any = this._element;
            if (!after._resizers) {
                after._resizers = [];
                ResizeSignal._observer.observe(this._element);
            }
            after._resizers.push(this);
        }
    }

    public dispose(): void {
        this.element = null;
        super.dispose();
    }

    private static createObserver(): void {
        if (this._observer)
            return;
        this._observer = new ResizeObserver((entries) => {
            for (var entry of entries) {
                var resizers = (entry.target as any)._resizers as ResizeSignal[];
                for (var resize of resizers) {
                    resize.dispatch(resize.element, entry.contentRect);
                }
            }
        });
    }
}